<div class="container">

  <h2>Cardio</h2>

  <form [formGroup]="form" (ngSubmit)="salvar()">

    <div class="form-floating mb-3">
      <input formControlName="nome" class="form-control" placeholder="Nome">
      <label>Nome</label>
    </div>

    <div class="form-floating mb-3">
      <input type="number" formControlName="distanciaAlvoKm" class="form-control" placeholder="Distância">
      <label>Distância alvo (Km)</label>
    </div>

    <div class="form-floating mb-3">
      <input type="number" formControlName="minutos" class="form-control" placeholder="Minutos">
      <label>Tempo (minutos)</label>
    </div>

    <div class="d-flex gap-2 mt-3">
      <button type="submit" class="btn btn-primary">Salvar</button>
      <button type="button" (click)="novo()" class="btn btn-secondary">Novo</button>
    </div>

  </form>

  <hr>

  <table mat-table [dataSource]="dataSource" matSort class="mt-2">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
      <td mat-cell *matCellDef="let element">{{element.id}}</td>
    </ng-container>

    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
      <td mat-cell *matCellDef="let element">{{element.nome}}</td>
    </ng-container>

    <ng-container matColumnDef="distancia">
      <th mat-header-cell *matHeaderCellDef>Km</th>
      <td mat-cell *matCellDef="let element">{{element.distanciaAlvoKm}}</td>
    </ng-container>

    <ng-container matColumnDef="minutos">
      <th mat-header-cell *matHeaderCellDef>Min</th>
      <td mat-cell *matCellDef="let element">{{element.minutos}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div class="btn-group">
          <button class="btn btn-sm" (click)="editar(row)">
            <i class="bi bi-pen-fill"></i>
          </button>
          <button class="btn btn-sm" (click)="remover(row.id)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>

</div>